export class EditionLayerAttr {
  public camp: string;
  public editable: boolean;
  public format: string;
  public longitudMax: number;
  public nom: string;
  public obligatori: boolean;
  public valors: Array<Object> = [];
  public amagat: boolean;
  public privat = false;
  public link: string;
  public removeIfEmpty = false;
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/models/edition-layer-attr.ts